import roadmap from "../../assets/roadmap-strategy.jpg";

const steps = [
  { n: "01", title: "Capture context", desc: "A short, structured input on your workflows, data maturity, and priorities." },
  { n: "02", title: "Run the Signal Score", desc: "Get a quantified readiness view across opportunity, data, and team dimensions." },
  { n: "03", title: "Surface ROI bands", desc: "See where AI is most likely to deliver measurable, defensible business value." },
  { n: "04", title: "Receive a 90-day plan", desc: "A sequenced, low-risk execution roadmap your leadership team can act on." },
];

const HowItWorks = () => {
  return (
    <section id="how" className="py-12 lg:py-14">
      <div className="container-tight">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <span className="eyebrow">How it works</span>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
              From AI conversation to executable plan in days, not quarters.
            </h2>
            <p className="mt-5 text-base text-muted-foreground">
              Designed to help you <span className="font-medium text-foreground">start</span> not overcommit.
            </p>

            <div className="mt-8 overflow-hidden rounded-2xl border border-border shadow-card">
              <img
                src={roadmap}
                alt="Strategy roadmap with quarterly milestones"
                width={1200}
                height={800}
                loading="lazy"
                className="h-auto w-full object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="space-y-3">
              {steps.map((s) => (
                <div key={s.n} className="group flex gap-6 rounded-2xl border border-border bg-card p-6 shadow-soft transition-all hover:border-signal/40 hover:shadow-card">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary font-serif text-xl text-foreground transition-colors group-hover:bg-foreground group-hover:text-background">
                    {s.n}
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-foreground">{s.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
